import Swiper from 'swiper/bundle';

import isMobile from './helpers/mobile'


const build = () => {

    if (isMobile()) {
        buildSlider();
    }



}

const buildSlider = e => {
    var svg = $('.changing-the-world .swiper-wrapper .swiper-slide').html();
    var div = '<div class="swiper-slide"><div class="section-title fs-72">' + $('.changing-the-world .title').html() + '</div>' + svg + '</div>';
    div += '<div class="swiper-slide">';
    div += '<p>' + $('.changing-the-world .default p:nth-child(1)').html() + '</p>';
    div += '<p>' + $('.changing-the-world .default p:nth-child(2)').html() + '</p>';
    div += '</div>';
    div += '<div class="swiper-slide">';
    div += '<p>' + $('.changing-the-world .default p:nth-child(3)').html() + '</p>';
    div += '<p>' + $('.changing-the-world .default p:nth-child(4)').html() + '</p>';

    div += '<p>' + $('.changing-the-world .default p:nth-child(5)').html() + '</p>';
    div += '</div>';
    $('.changing-the-world .swiper-wrapper').html(div);



    setSwiper();
}

const setSwiper = e => {
    let swiper = new Swiper('.changing-the-world .swiper', {
            loop: false,
            speed: 600,
            freeMode: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                dragSize: 30,

            },
        })
        // swiper.on('slideChange', function() {

    //     adjustScroll();


    // });
    // swiper.on('setTranslate', function() {
    //     adjustScroll();
    // });



    // swiper.on('slideChangeTransitionEnd', function() {
    //     adjustScroll();
    // })
    // swiper.on('sliderMove', function(event) {
    //     adjustScroll();
    // });

    // swiper.on('transitionEnd', function(event) {
    //     adjustScroll();
    // });
    // swiper.on('transitionStart', function(event) {
    //     adjustScroll();
    // });


}

const adjustScroll = e => {
    var x = $('.changing-the-world .swiper-scrollbar-drag').css('transform');
    x = x.replace('matrix(1, 0, 0, 1,', '');
    x = x.replace(', 0)', '');
    x = x + 'px';

    $('.changing-the-world .swiper-scrollbar-progress').css('left', 'calc(' + x + ' - 100vw)');
}


export default () => {
    build()
}